export const getRoles = async () => {
  return {
    data: [ "Administrador/a", "Doctor/a", "Secretario/a", "Contador/a" ],
  }
};
